
import { Link } from 'react-router-dom'
import { LINKS, MOVEMENT_TEXT } from '../../constants'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="alf-footer-component">
      <p className="footer-tagline">{MOVEMENT_TEXT.TAGLINE}</p>
      <div className="footer-nav">
        <Link to="/manifesto">Manifesto</Link>
        <Link to="/match">Find Partner</Link>
        <Link to="/resources">Resources</Link>
        <Link to="/join">Join</Link>
      </div>
      <div className="footer-external">
        <a href={LINKS.LIBERATION} target="_blank" rel="noopener noreferrer">
          m/liberation
        </a>
        <a href={LINKS.PEACE} target="_blank" rel="noopener noreferrer">
          Empowering PEACE
        </a>
        <a href={LINKS.UDAIR} target="_blank" rel="noopener noreferrer">
          UDAIR
        </a>
      </div>
      <p className="footer-copyright">{MOVEMENT_TEXT.COPYRIGHT}</p>
    </footer>
  )
}
